import React from 'react'
import propTypes from 'prop-types'

function Input(props) {
  const className = [props.className]
  className.push('form-control')
  if (props.hasIcon) {
    return (
      <>
        <input type="text" placeholder={props.placeholder} className={className.join(' ')}/>
      </>
    )
  }
  return (
    <>
      <input type="text" placeholder={props.placeholder} className={className.join(' ')}/>
    </>
  )
}

export default Input

Input.propTypes = {
  type: propTypes.oneOf(['text', 'file', 'radio', 'checkbox']),
  placeholder: propTypes.string,
  hasIcon: propTypes.bool
}